import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export const scrollToSection = (sectionId: string, offset = 0) => {
    const target = document.getElementById(sectionId);
    if (target) {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;
        gsap.to(window, { duration: 1, scrollTo: targetPosition });
    }
};

